"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillBreakdownTable = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var Tooltip_1 = require("../../../../../../../shared/core/components/Tooltip");
var ProgressBar_1 = require("../../../../../components/ProgressBar");
var copy_1 = require("../../../../../copy");
var BillBreakdownTable_styled_1 = require("./BillBreakdownTable.styled");
var BillBreakdownTable = function (_a) {
    var dataTable = _a.dataTable, totalCharge = _a.totalCharge;
    var DataTable = (0, core_1.useComponents)().DataTable;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    return (react_1.default.createElement(BillBreakdownTable_styled_1.StyledTableWrapper, null,
        react_1.default.createElement(BillBreakdownTable_styled_1.StyledTable, { as: DataTable, items: dataTable
                .filter(function (_a) {
                var amount = _a.amount;
                return !!amount;
            })
                .map(function (row, index) { return [
                row.hideProgressBar ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(BillBreakdownTable_styled_1.Wrap, null, row.label),
                    ' ',
                    react_1.default.createElement(Tooltip_1.TooltipTrigger, { tooltip: row.tooltipDescription, key: index }))) : (react_1.default.createElement(BillBreakdownTable_styled_1.Wrap, null, row.label)),
                !row.hideProgressBar && (react_1.default.createElement(Tooltip_1.TooltipTrigger, { tooltip: row.tooltipDescription, key: index },
                    react_1.default.createElement(ProgressBar_1.ProgressBar, { total: totalCharge, progress: row.amount, accessibleProgressDescription: row.accessibleProgressDescription }))),
                (0, core_1.major2DP)((0, core_1.majorToMinor)(row.amount)),
            ]; }), "data-testid": "breakdown-table", striped: false, rowHeadings: true, caption: copy('breakdownLabel'), columnWidths: ['160px', 'auto', '80px'] })));
};
exports.BillBreakdownTable = BillBreakdownTable;
